import React, { useState } from 'react';
import Modal from '../design-system/ui/modal';
import { capturePosthogEvent } from '../utils';

interface IProps {
  show: boolean;
  onClose: () => void;
}

const FeedbackModal: React.FC<IProps> = ({ show, onClose }) => {
  const [feedbackText, setFeedbackText] = useState('');
  const [isSending, setIsSending] = useState(false);

  const handleSend = () => {
    setIsSending(true);
    capturePosthogEvent('broken_screen_feedback_submitted', {
      feedback: feedbackText,
    });
    setIsSending(false);
    onClose();
  };

  const handleCancel = () => {
    setFeedbackText('');
    onClose();
  };

  const title = (
    <div className="error-feedback-modal__title">
      <h2>It looks like we&apos;re having issues.</h2>
      <p>
        Our team has been notified. If you&apos;d like to help, tell us what
        happened below.
      </p>
    </div>
  );

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      className="error-feedback-modal"
      title={title}
      variant="border"
      backdrop="static"
      secondaryBtnLabel="Cancel"
      primaryBtnLabel="Send crash report"
      secondaryBtnClickedHandler={handleCancel}
      primaryBtnClickedHandler={handleSend}
      primaryBtnLoading={isSending}
      primaryBtnDisabled={!feedbackText.trim() || isSending}
    >
      <div className="error-feedback-modal__body">
        <span className="error-feedback-modal__label">What happened?</span>
        <textarea
          className="error-feedback-modal__textarea"
          placeholder="I clicked on the 'X' and then hit 'Confirm'"
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
          rows={5}
          aria-label="What happened?"
        />
      </div>
    </Modal>
  );
};

export default FeedbackModal;
